<template>
    <section id="paymentSuccessDiv">
        <div class="container mt-5">
            <!-- Jumbotron -->
            <div class="px-4 py-5 px-md-5 text-center text-lg-start paymentSuccessContain">
                <div class="container">
                    <div class="row gx-lg-5 align-items-center">
                        <div class="col-lg-6 mb-5 mb-lg-0">
                            <img class="pt-7 pt-md-0 success-img" src="../../assets/img/reg.png" alt="Payment Successful">
                            <h1 class="my-5 display-3 fw-bold ls-tight">
                                Payment Successful! <br />
                                <span class="text-success">Thank you for your purchase</span>
                            </h1>
                            <p style="color: hsl(217, 10%, 50.8%)">
                                Your payment has been successfully processed. We appreciate your business and hope you enjoy the service or product you’ve purchased.
                            </p>
                        </div>

                        <div class="col-lg-6 mb-5 mb-lg-0">
                            <div class="card" style="background-color: #f8f8f8;">
                                <div class="card-body py-5 px-md-5" id="paymentDetailsBox">
                                    
                                    <h5 class="card-title">Payment Details</h5>

                                    <div class="form-outline mb-4 mt-4">
                                        <label class="form-label" for="paymentId">Package Name</label>
                                        <p id="paymentId" class="form-control-plaintext">{{ packName }}</p>
                                    </div>
                                    
                                    <!-- Payment ID -->
                                    <div class="form-outline mb-4">
                                        <label class="form-label" for="paymentId">Payment ID</label>
                                        <p id="paymentId" class="form-control-plaintext">{{ paymentId }}</p>
                                    </div>

                                    <!-- Amount -->
                                    <div class="form-outline mb-4">
                                        <label class="form-label" for="paymentAmount">Amount Paid</label>
                                        <p id="paymentAmount" class="form-control-plaintext"> {{  }}</p>
                                    </div>

                                    <!-- Date -->
                                    <div class="form-outline mb-4">
                                        <label class="form-label" for="paymentDate">Payment Date</label>
                                        <p id="paymentDate" class="form-control-plaintext">{{ paymentDate }}</p>
                                    </div>

                                    <!-- Payment Method -->
                                    <div class="form-outline mb-4">
                                        <label class="form-label" for="paymentMethod">Payment Method</label>
                                        <p id="paymentMethod" class="form-control-plaintext">Visa Card</p>
                                    </div>

                                    <!-- Confirmation Message -->
                                    <div class="alert alert-success" role="alert" id="paymentSuccessMessage">
                                        Your payment has been successfully processed! You will receive an email with your receipt and details shortly.
                                    </div>

                                    <!-- Redirect button -->
                                    <div class="form-outline mt-5">
                                        <button class="col-md-12 btn btn-medium btn-primary" id="continueBtn" @click="redirectToHome">Continue</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Section: Design Block -->
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: 'PaymentSuccessPage',
    data() {
        return {
            paymentId: '',
            amountPaid: '',
            paymentDate: '',
            paymentMethod: '',
            packName:'',
            price:''
        };
    },
    created() {
    const urlParams = new URLSearchParams(window.location.search);
        // Extract URL parameters and update the data properties
        this.paymentId = urlParams.get('payID') || 'Not Available';
        this.amountPaid = urlParams.get('price') || 'Not Available';
        this.packName = urlParams.get('package_name') || 'Not Available';
        this.paymentDate = urlParams.get('payDate') || 'Not Available';
        this.price = urlParams.get('price') || 'Not Available';
        this.paymentMethod = this.$route.query.paymentMethod || 'Not Available';
    },
    methods: {
        redirectToHome() {
            // Redirect user to the homepage or another page after successful payment
            window.location.href = '/';  // Modify this to the desired page
        }
    }
}
</script>

<style scoped>
.paymentSuccessContain {
    background-color: #f5f5f5;
    padding: 50px 0;
}

.success-img {
    max-width: 100%;
    height: auto;
}

#paymentDetailsBox {
    background-color: #fff;
    border-radius: 8px;
    padding: 30px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.card-title {
    font-size: 1.5rem;
    font-weight: bold;
    color: #333;
}

.form-outline {
    margin-bottom: 20px;
}

.form-control-plaintext {
    font-size: 1.1rem;
    font-weight: 500;
}

.alert {
    font-size: 1rem;
    margin-top: 20px;
    padding: 15px;
}

#continueBtn {
    font-size: 1rem;
    padding: 12px;
    background-color: #007bff;
    color: white;
    border: none;
    cursor: pointer;
    border-radius: 5px;
}

#continueBtn:hover {
    background-color: #0056b3;
}
</style>
